import React from "react";
import { useLocation } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { FaAnglesRight } from "react-icons/fa6";
import "./FromPageIndicator.css";

const FromPageIndicator = () => {
  const location = useLocation();

  const fromPage = location.state?.from || "Home";
  const currentPage = location.pathname.split("/").pop() || "Current Page";

  return (
    <div className="from-page-indicator text-white">
      <div className="overlay">
        <Container>
          {/* <Row className="align-items-center text-center text-md-start py-4 flex-nowrap">
            <Col xs="auto" md={4} lg={1}>
              <h3 className="indicator-heading fw-bold">{fromPage}</h3>
            </Col>

            <Col xs="auto" md={1} className="d-flex justify-content-center">
              <FaAnglesRight size={28} />
            </Col>

            <Col xs="auto" md={4} lg={4}>
              <h3 className="indicator-heading fw-bold text-capitalize">
                {currentPage.replaceAll("-", " ")}
              </h3>
            </Col>
          </Row> */}
          <Row className="align-items-center text-center text-md-start py-4">
            <Col xs={12} md={4} lg={1}>
              <h3 className="indicator-heading fw-bold">{fromPage}</h3>
            </Col>

            <Col xs={12} md={1} className="d-flex justify-content-center">
              <FaAnglesRight size={28} />
            </Col>

            <Col xs={12} md={4} lg={4}>
              <h3 className="indicator-heading fw-bold text-capitalize">
                {currentPage.replaceAll("-", " ")}
              </h3>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default FromPageIndicator;
